import { isRouteErrorResponse, useRouteError } from "react-router";

import { NotFoundPage } from "@/routes/not-found";

/**
 * Anything thrown below the root lands here.
 *
 * A 404 Response, which is what the detail loaders throw for an unknown slug,
 * renders the same page a wrong URL would. Everything else gets a plain
 * apology: the details go to the server log, not to the visitor, because a
 * stack trace on a public page is an invitation.
 */
export function ErrorBoundary() {
  const error = useRouteError();

  if (isRouteErrorResponse(error) && error.status === 404) {
    return <NotFoundPage />;
  }

  return (
    <section className="container-page py-32">
      <p className="eyebrow">Something went wrong</p>
      <h1 className="mt-3" style={{ fontSize: "var(--step-h1)" }}>
        This page could not be loaded
      </h1>
      <p className="mt-5 max-w-2xl text-muted" style={{ fontSize: "var(--step-lead)" }}>
        The problem has been logged. Please try again in a moment, or use the navigation to reach
        another part of the site.
      </p>
    </section>
  );
}
